export { ChevronsDown2 } from "./ChevronsDown2";
